import WebLogin from "@/interfaces/WebLogin/WebLogin";

export function getAccountNameInitials(fullName: string): string {
  if (!fullName) return "";

  const namePartArray = fullName.split(" ");

  let initials = "";
  for (const namePart of namePartArray) {
    if (initials.length < 2) {
      if (/^[a-zA-Z]+$/.test(namePart[0])) {
        initials += namePart[0];
      }
    }
  }

  return initials.toUpperCase();
}

export function getWebLoginFromJsonWebToken(jwt: string): WebLogin {
  const jwtParts = jwt.split(".");

  if (jwtParts.length < 2 || !jwtParts[1]) {
    throw new Error("JWT payload is missing.");
  }

  let jwtParsed: Record<string, string>;

  try {
    jwtParsed = JSON.parse(atob(jwtParts[1])) as Record<string, string>;
  } catch (error) {
    throw new Error(
      `JWT payload is invalid: ${
        error instanceof Error ? error.message : "Unknown parsing error."
      }`
    );
  }

  return {
    webLoginId: jwtParsed.webLoginId,
    webLoginUserName: jwtParsed.webLoginUserName,
    keepLoggedIn: jwtParsed.keepLoggedIn === "True",
    isEmployee: jwtParsed.isEmployee === "True",
    employeeSecurity: parseInt(jwtParsed.employeeSecurity),
    employeeCustomerAccess: parseInt(jwtParsed.employeeCustomerAccess),
    employeeManagerName: jwtParsed.employeeManagerName,
    forcePasswordChange: jwtParsed.forcePasswordChange === "True",
  } as WebLogin;
}
